import { AppInsightsContext } from '@microsoft/applicationinsights-react-js'
import { HelmetProvider } from 'react-helmet-async'
import { SafeAreaProvider } from 'react-native-safe-area-context'
import { Provider as StoreProvider } from 'react-redux'

import { reactPlugin } from '@app/services/logging'

import { Toaster } from '@lib/components/Toaster'

import { AppContainer } from './AppContainer'
import { store } from './store'

export const App = () => (
  <HelmetProvider>
    <SafeAreaProvider>
      <AppInsightsContext.Provider value={reactPlugin}>
        <StoreProvider store={store}>
          <AppContainer />
          <Toaster />
        </StoreProvider>
      </AppInsightsContext.Provider>
    </SafeAreaProvider>
  </HelmetProvider>
)
